// extracted by mini-css-extract-plugin
export default {"Container":"Common_Container__32ddE","MainContent":"Common_MainContent__Q55h3","Content":"Common_Content__ls8M0"};